export enum AbTestVariant {
    'EMPTY' = '',
    'A' = 'A',
    'B' = 'B',
    'C' = 'C',
    'D' = 'D',
    'E' = 'E',
    'F' = 'F',
    'G' = 'G',
}

export interface ExperimentConfigInterface {
    passwordlessExperimentConfig: PasswordlessExperimentConfig;
}

export interface PasswordlessExperimentConfig {
    passwordlessVariant: AbTestVariant;
}

export enum ABTestKeys {
    'TEST_KEY' = 'TEST_KEY',
}
